/// <amd-module name="Artifacts/Cargo/commands/PermanentDelete" />
import { CargoActions } from "Artifacts/Cargo/redux";
import { getPermanentDeleteCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createPermanentDeleteCommand = getPermanentDeleteCommandCreator(
  CargoActions.permanentDelete,
);
